import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UiIdService {
  private lastId = -1;

  getNextId(): number {
    return ++this.lastId;
  }
}
